export interface TimeRange {
  readonly start: number;

  readonly end: number;
}
